<template lang="pug">
div
  Query(
    :query="require('~/graphql/Article.gql').Articles"
    :limit="2"
    :variables="{ innovator: tags  }"
    v-slot="{ items }" 
    :moreButton="false"
  )
    AsymetricGrid(:items="items" ref="grid" v-slot="{ item, ratio }")
        AppCard.is-large( :img="[{ srcset: item.thumb, type: 'image/jpg' }]"  ratio="1:1" :url="`/articles/${item.slug}`" :title="item.title")
  
   

</template>

<script>
import AsymetricGrid from '~/components/PsudoRandomGrid';
import Query from '~/components/Query';

export default {
  name: 'ArticleTeam',
  props: {
    tags: {
      type: String,
      required: true
    }
  },
  components: {
    AsymetricGrid,
    Query
  },
  data: () => ({
    selectedItem: {}
  }),

  async created() {},

  methods: {
    onLeave() {
      this.selectedItem = {
        likes: 0,
        id: null,
        caption: '',
        media: { src: '' }
      };
    },
    async like() {},
    onSelect(item) {
      this.selectedItem = item;
    }
  }
};
</script>
